import { useState, useEffect } from 'react'
import { initOnboard } from '../utils/onboard'
import { useConnectWallet, useSetChain, useWallets } from '@web3-onboard/react'
import { config } from '../dapp.config'
import {
  getTotalMinted,
  getMaxSupply,
  isPausedState,
  isPublicSaleState,
  publicMint,
  getPrice,
  NETWORKS,
  getRemainingTokens
} from '../utils/interact'
import CustomDropdown from '../components/UI/CustomDropdown'

export default function Mint() {
  const [{ wallet }, connect, disconnect] = useConnectWallet()
  const [{ connectedChain }] = useSetChain()
  const connectedWallets = useWallets()

  const [maxSupply, setMaxSupply] = useState(0)
  const [totalMinted, setTotalMinted] = useState(0)
  const [paused, setPaused] = useState(false)
  const [price, setPrice] = useState(0)
  const [isPrivateSale, setisPrivateSale] = useState(true)

  const [status, setStatus] = useState(null)
  const [mintAmount, setMintAmount] = useState(1)
  const [isMinting, setIsMinting] = useState(false)
  const [onboard, setOnboard] = useState(null)
  const [dropDownValue, setDropDownValue] = useState(0)
  const [loading, setLoading] = useState(false)
  const [network, setNetwork] = useState('')
  const [isTokensRemaining, setIsTokensRemaining] = useState(false)

  const imageToSelect = [
    'COMMON',
    'RARE',
    'ULTRARARE',
    'LEGENDARY',
  ]
    const honeyAlloToSelect = [
    '4378',
    '8756',
    '17513',
    '35026',
    '70052'
  ]
   const rarityDescription = [
    'Common: Bears are availabe in a variety of colors',
    'Rare: Gold Bears are recognizable by their golden fur',
    'Ulta Rare: White Polar Bears are recognizable by their white fur',
    'Legendary: Diamond Polar Bears are recognizable by their diamond fur',
  ]

  useEffect(() => {
    setOnboard(initOnboard)
  }, [])

  useEffect(() => {
    if (connectedChain?.id === '0x250') {
      setNetwork(NETWORKS.astar)
    } else if (connectedChain?.id === '0x504') {
      setNetwork(NETWORKS.moonbeam)
    }
  }, [connectedChain?.id])

  useEffect(() => {
    if (!connectedWallets.length) return

    const connectedWalletsLabelArray = connectedWallets.map(
      ({ label }) => label
    )

    window.localStorage.setItem(
      'connectedWallets',
      JSON.stringify(connectedWalletsLabelArray)
    )
  }, [connectedWallets])

  useEffect(() => {
    if (!onboard) return

    const previouslyConnectedWallets = JSON.parse(
      window.localStorage.getItem('connectedWallets')
    )

    if (previouslyConnectedWallets?.length) {
      async function setWalletFromLocalStorage() {
        await connect({
          autoSelect: {
            label: previouslyConnectedWallets[0],
            disableModals: true
          }
        })
      }

      setWalletFromLocalStorage()
    }
  }, [onboard, connect])

  useEffect(() => {
    const init = async () => {
      setLoading(true)
      setMaxSupply(await getMaxSupply(network))
      setTotalMinted(await getTotalMinted(network))
      setPaused(await isPausedState(network))
      setisPrivateSale(await isPublicSaleState(network))

      const price = await getPrice(network, dropDownValue)
      setPrice(price)
      setLoading(false)
    }

    if (network) {
      init()
    }
  }, [dropDownValue, network])

  useEffect(() => {
    const getRemainTokens = async () => {
      const check = await getRemainingTokens(network, dropDownValue)
      setIsTokensRemaining(check)
      return check
    }

    if (network) {
      getRemainTokens()
    }
  }, [dropDownValue, network])

  const incrementMintAmount = () => {
    if (mintAmount < 300 && !isPrivateSale) {
      setMintAmount(mintAmount + 1)
    }
  }

  const decrementMintAmount = () => {
    if (mintAmount > 1) {
      setMintAmount(mintAmount - 1)
    }
  }

  const publicMintHandler = async () => {
    setIsMinting(true)
    if (connectedChain?.id == '0x504' || connectedChain?.id == '0x250') {
      const { success, status } = await publicMint(
        network,
        mintAmount,
        connectedWallets,
        dropDownValue
      )
      setStatus({
        success,
        message: status
      })
      setMaxSupply(await getMaxSupply(network))
      setTotalMinted(await getTotalMinted(network))
    } else {
      setStatus({
        success: false,
        message: 'Change your network'
      })
    }
    setIsMinting(false)
  }

  return (
    <div className="flex flex-col items-center justify-center w-full h-full min-h-screen overflow-hidden bg-brand-background">
      <div className="relative flex flex-col items-center justify-center w-full h-full">
        <img
          src="/images/honeyboard.png"
          className="absolute inset-auto block object-cover w-full min-h-screen animate-pulse-slow"
        />

        <div className="flex flex-col items-center justify-center w-full h-full px-2 md:px-10">
          <div className="relative flex flex-col items-center w-full px-2 py-4 rounded-md z-1 md:max-w-3xl bg-gray-900 filter backdrop-blur-sm md:px-10">
            {wallet && (
              <button
                className="absolute right-4 bg-indigo-600 transition duration-200 ease-in-out font-chalk border-2 border-[rgba(0,0,0,1)] shadow-[0px_3px_0px_0px_rgba(0,0,0,1)] active:shadow-none px-4 py-2 rounded-md text-sm text-white tracking-wide uppercase"
                onClick={() =>
                  disconnect({
                    label: wallet.label
                  })
                }
              >
                Disconnect
              </button>
            )}
            <button className="mt-3 text-3xl font-bold text-transparent uppercase font-coiny md:text-4xl bg-gradient-to-br from-brand-green to-brand-blue bg-clip-text">
              {paused ? 'Paused' : 'Public Sale'}
            </button>
            <h3 className="text-sm tracking-widest text-blue-200">
              {wallet?.accounts[0]?.address
                ? wallet?.accounts[0]?.address.slice(0, 8) +
                  '...' +
                  wallet?.accounts[0]?.address.slice(-4)
                : ''}
            </h3>

            <div className="flex flex-col w-full px-4 mt-10 md:flex-row md:space-x-14 md:mt-14">
              <div className="relative w-full">
                <div className="absolute z-10 flex items-center justify-center px-2 pt-2 text-base font-semibold text-white bg-black border rounded-md font-coiny top-2 left-2 opacity-80 filter backdrop-blur-lg border-brand-blue">
                  <p>
                    <span className="text-brand-blue">{totalMinted}</span> /{' '}
                    {maxSupply}
                  </p>
                </div>

                <img
                  src={`images/bear-images/${imageToSelect[dropDownValue]}.png`}
                  className="object-cover w-full sm:h-[280px] md:h-[320px] md:w-[300px] rounded-md"
                />
                 <p className="mt-3 px-2 text-base font-bold text-white">
                  {`${rarityDescription[dropDownValue]}`}{' '}
                  </p>
              </div>

              <div className="flex flex-col items-center w-full mt-16 md:mt-0">
                <div className="flex items-center justify-around w-full px-3 font-coiny">
                  <button
                    className="flex items-center justify-center h-10 font-bold bg-gray-300 rounded-md w-14 md:w-16 md:h-12 text-brand-background hover:shadow-lg"
                    onClick={incrementMintAmount}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-6 h-6 md:h-8 md:w-8"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                      />
                    </svg>
                  </button>

                  <p className="flex items-center justify-center flex-1 text-3xl font-bold text-center grow text-brand-blue md:text-4xl">
                    {mintAmount}
                  </p>

                  <button
                    className="flex items-center justify-center h-10 font-bold bg-gray-300 rounded-md w-14 md:w-16 md:h-12 text-brand-background hover:shadow-lg"
                    onClick={decrementMintAmount}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-6 h-6 md:h-8 md:w-8"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M18 12H6"
                      />
                    </svg>
                  </button>
                </div>

                <CustomDropdown onDropDownValueChange={setDropDownValue} />

                <div className="w-full pt-2 mt-16 border-t border-b">
                  <div className="flex items-center justify-between w-full text-xl text-white font-coiny">
                    <p>Total</p>

                    {loading ? (
                      <div className="flex flex-col items-center">
                        <div className="h-8 mb-3 bg-gray-400 rounded w-52 animate-pulse"></div>
                      </div>
                    ) : (
                      <div className="flex items-start space-x-3">
                        <p>
                          {Number.parseFloat(price * mintAmount)}{' '}
                          {network === NETWORKS.astar ? 'ASTR' : 'GLMR'}
                        </p>{' '}
                        <span className="text-gray-400">+ GAS</span>
                      </div>
                    )}
                  </div>
                </div>
                {isTokensRemaining && (
                  <div className="p-2 mt-10 text-white border rounded">
                    This rarity has sold out!
                  </div>
                )}

                {/* Mint Button && Connect Wallet Button */}
                {wallet ? (
                  <a
                  className={` ${
                    'bg-gradient-to-br from-brand-purple to-brand-blue shadow-lg hover:shadow-blue-400/50'
                  } font-coiny mt-4 w-full px-6 rounded-md text-2xl text-white  mx-4 tracking-wide uppercase`}
                  target="_blank"
                  rel="noopener noreferrer"
                  href={network === NETWORKS.astar ? 'https://www.bluez.app/cult_bears' : 'https://tofunft.com/collection/cultbears-moonbeam/items'}
                  > 
                  <button
                  className={`font-coiny w-full py-3 rounded-md text-2xl text-white mx-6 tracking-wide uppercase`}
                  target="_blank"
                  rel="noopener noreferrer"
                  href={network === NETWORKS.astar ? 'https://www.bluez.app/cult_bears' : 'https://tofunft.com/collection/cultbears-moonbeam/items'}
                  >
                  {network === NETWORKS.astar ? 'Buy on Bluez' : 'Buy on ToFu'} 
                  </button>
                  </a>
                ) : (
                  <button
                    className="w-full px-6 py-3 mx-4 mt-12 text-2xl tracking-wide text-white uppercase rounded-md shadow-lg font-coiny bg-gradient-to-br from-brand-purple to-brand-blue hover:shadow-blue-400/50"
                    onClick={() => connect()}
                  >
                    Connect Wallet
                  </button>
                )}
              </div>
            </div>

            {/* Status */}
            {status}
            {/* {status && (
              <div
                className={`border ${
                  status.success ? 'border-green-500' : 'border-brand-blue-400 '
                } rounded-md text-start h-full px-4 py-4 w-full mx-auto mt-8 md:mt-4"`}
              >
                <p className="flex flex-col space-y-2 text-white text-sm md:text-base break-words ...">
                  {status.message}
                </p>
              </div>
            )}
            */}
            

            {/* XHNY Allocation & Contract Address */}
            <div className="flex flex-col items-center w-full py-2 mt-4 border-t border-gray-800">
              
               <h3 className="mt-2 text-2xl text-transparent uppercase font-coiny text bg-gradient-to-br from-brand-green to-brand-blue bg-clip-text">
                $XHNY Allocation
              </h3>

                 <p className="mt-2 text-gray-400">
                  {`${honeyAlloToSelect[dropDownValue] * mintAmount}`}{' '}
                  $XHNY 🍯⛓️
                  </p>
                 
              <h3 className="mt-2 text-2xl text-transparent uppercase font-coiny text bg-gradient-to-br from-brand-green to-brand-blue bg-clip-text">
                Contract Address
              </h3>
              <a
                href={network === NETWORKS.astar ? `https://astar.blockscout.com/address/${config.contractAddress}` : `https://moonscan.io/address/${config.contractAddress}`}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-2 text-gray-400"
              >
                <span className="break-all ...">{config.contractAddress}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
